import {  useEffect, useState } from "react";
import { Col, Container, Dropdown, Offcanvas, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import ThemeToggle from '../themeToggle/ThemeToggle';
import CommonButton from "../commonButton/CommonButton";
import './Header.scss';
import HeaderMenu from "./HeaderMenu";
import { useAppSelector } from '../../../redux/hooks/Hooks';
import LogoWhite from '../../../assets/images/logo_white.svg';
import LogoDark from '../../../assets/images/logo_dark.svg';
import FaviconDark from '../../../assets/images/favicondark.svg'
import FaviconLight from '../../../assets/images/faviconlight.svg'
import WalletIcon from '../../../assets/images/metamask.png';
import Balance from "./Balance";
import { CopyIcon } from "../../../assets/svgIcons/svgIcons";
import {useHandleWalletConnection} from "../../common/customHooks/walletConnect";
import { formatAddress } from "../../../utils/commonUtils";
import CopyToClipboard from 'react-copy-to-clipboard';
import { Toast } from "../toast/Toast";
const Header = ({ logoClick }: { logoClick?: any }) => {
  const theme = useAppSelector((state) => state.theme.theme);
  const [show, setShow] = useState(false);
  const [mobilemenu, setMobileMenu] = useState(true);
  const [state, setState] = useState({
    copySuccess: false,
  });
  const {open, isConnected, address, disconnect} = useHandleWalletConnection();
  const handleResize = () => {
    if (window.innerWidth < 992) {
      setMobileMenu(false);
    } else {
      setMobileMenu(true);
    }
  }

  const handleCopy = () => {
    setState((prevState: any) => ({ ...prevState, copySuccess: true }));
    Toast.success('Copied');
    setTimeout(
      () =>
        setState((prevState: any) => ({ ...prevState, copySuccess: false })),
      3000,
    );
  };

  useEffect(() => {
    handleResize();
    return () => {
      window.addEventListener('resize', handleResize)
    }
  }, []);
  return (
    <header className="header">
      <Container fluid>
        <Row className="align-items-center">
          <Col xs={3} lg={3}>
            <div className={`header_left ${theme}`}>
              {mobilemenu ?
                <Link to="/" onClick={logoClick}><img src={theme === "dark" ? LogoWhite : LogoDark} alt="" /></Link>
                :
                <Link className="header_left_mobile" to="/" onClick={logoClick}><img src={theme === "dark" ? FaviconDark : FaviconLight} alt="" /></Link>
              }
            </div>
          </Col>
          <Col xs={9} lg={9} className="ps-0">
            <div className="header_right">
              {mobilemenu
                ?
                <HeaderMenu onClick={() => { setShow(!show) }} />
                :
                <Offcanvas show={show} onHide={() => { setShow(false) }} placement="end" className="header_canvas">
                  <Offcanvas.Header closeButton>
                    <Offcanvas.Title><img src={theme === "dark" ? LogoWhite : LogoDark} alt="" /></Offcanvas.Title>
                  </Offcanvas.Header>
                  <Offcanvas.Body>
                    <HeaderMenu className="header_menu_canvas" onClick={() => { setShow(!show) }} />
                    <Balance className={theme === "dark" ? "" : "btn-bordered"} points="450" balance="$0.00" />
                  </Offcanvas.Body>
                </Offcanvas>
              }
              {isConnected && address ?
                <>
                  <Balance className={theme === "dark" ? "" : "btn-bordered"} points="450" balance="$0.00" />
                  <Dropdown className="header_right_userdrop">
                    <Dropdown.Toggle id="walletdrop">
                      <span><img src={WalletIcon} alt="" /></span>
                    </Dropdown.Toggle>
                    <Dropdown.Menu align="end">
                      <h5>Welcome to Stronghodl</h5>
                      <h5 className="address">Wallet Address:</h5>
                      <CopyToClipboard text={address} onCopy={handleCopy}>
                      <p className="copyaddress"><span>{formatAddress(address)}</span> <button type="button"><CopyIcon/></button></p></CopyToClipboard>
                      <hr />
                      <CommonButton title="Disconnect Wallet" onClick={disconnect} />
                    </Dropdown.Menu>
                  </Dropdown>
                </> : <CommonButton title="Connect Wallet" className="btn-small btn-secondary connect" onClick={open} />}
              <ThemeToggle />
              {mobilemenu ? "" : <button onClick={() => { setShow(true) }} className="menubtn"><span></span> <span></span> <span></span></button>}
            </div>
          </Col>
        </Row>
      </Container>
    </header>
  )
}
export default Header